<template>
  <b-row>
    <b-col>
      <b-container class="p-0">
        <b-nav tabs fill>
          <b-nav-item v-for="status in status_codes" :key="status.id" :active="activeStatusId === status.id"
            @click="setActiveStatus(status.id)">
            {{ status.label }}
          </b-nav-item>
        </b-nav>
        <!-- Loading message -->
        <div v-if="loading" class="text-center text-muted p-4">
          <b-spinner small class="mr-2"></b-spinner>
          Loading policies, please wait...
        </div>

        <!-- No results -->
        <div v-else-if="policies.length === 0" class="text-center text-muted p-4">
          <b-icon icon="inbox" font-scale="1.5"></b-icon>
          <div class="mt-2">No policies found.</div>
        </div>

        <!-- Table only when data is available -->
        <div v-else>
          <b-form-input class="mt-2" id="filter-input" v-model="filter" type="search"
            placeholder="Filter Policy List"></b-form-input>
          <b-table :filter="filter" :items="policies" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            responsive="sm">
            <template #cell(policy_number)="data">
              <a :href="`/policy/${data.item.id}`">{{ data.item.policy_number }}</a>
            </template>

            <template #cell(coverage_line)="data">
              <b class="text-info">{{ data.item.coverage_line }}</b>
            </template>

            <template #cell(insurance_name)="data">
              {{ data.item.insurance_name }}
            </template>

            <template #cell(label)="data">
              <i>{{ data.item.label }}</i>
            </template>
<template #cell(date_effective)="data">
  {{ data.item.date_effective | onlyDate }}
</template>

<template #cell(date_renewal)="data">
  {{ data.item.date_renewal | onlyDate }}
</template>            
          </b-table>
        </div>

      </b-container>
    </b-col>

    <b-col cols="4">
      <b-list-group>
        <b-list-group-item variant="secondary">
          <h3 class="m-0">Active Tasks</h3>
        </b-list-group-item>
        <b-list-group-item v-for="task in tasks" :key="task.task_id">
          <a :href="`/task/${task.task_id}`">{{ task.subject }}</a><br />
          <small>{{ formatDateDue(task.date_due) }}</small>
        </b-list-group-item>
      </b-list-group>
    </b-col>
  </b-row>
</template>

<script>
import PolicyDataService from '@/services/PolicyDataService';
import ReferenceDataService from '@/services/ReferenceDataService';
import TaskDataService from '@/services/TaskDataService';

export default {
  props: ['company'],
  data() {
    return {
      loading: false,
      sortBy: 'age',
      sortDesc: false,
      filter: '',
fields: [
  { key: 'policy_number', label: 'Policy #', sortable: true },
  { key: 'date_effective', label: 'Effective', sortable: true },
  { key: 'date_renewal', label: 'Renew', sortable: true },
  { key: 'lineofcoverage_name', label: 'Line of Coverage', sortable: true },
  { key: 'policy_type_name', label: 'Policy Type', sortable: true },
],
      policies: [],
      sidebarad: false,
      status_codes: [],
      activeStatusId: 6,
      tasks: [],
      sorting: 'date_due,asc',
      statuscodes: '1,2,3',
      limit: 10,
      is_underwriter: localStorage.getItem('underwriter'),
      is_admin: localStorage.getItem('admin'),
    };
  },
  created() {
    const allStatusCodes = ReferenceDataService.policy_status_codes();

    this.status_codes = allStatusCodes
      .filter((status) => {
        const allowedLabels = [
          'Quoting',
          'Quoted',
          'Unbound',
          'Underwriting',
          'Overdue',
          'My Renewals',
          'Renewals',
        ];

        if (!allowedLabels.includes(status.label)) {
          return false;
        }

        if (this.is_underwriter === 1 || this.is_admin === 1) {
          return status.allowed !== 1;
        }

        return true;
      })
      .concat([
        { id: 9991, label: 'Overdue', allowed: 1 },
        { id: 9992, label: 'My Renewals', allowed: 1 },
        { id: 9993, label: 'Renewals', allowed: 1 },
        { id: 9994, label: 'Recently Touched', allowed: 1 },
      ]);

    TaskDataService.getAll(this.statuscodes, '', this.sorting, this.limit)
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          this.tasks = res.data;
        } else {
          this.tasks = [];
        }
      })
      .catch((err) => {
        this.tasks = [];
        this.$emit('error', err);
      });

    this.getPolicyByStatus(this.activeStatusId);
  },
  methods: {
    async getPolicyByStatus(statusId) {
      this.loading = true;
      try {
        const res = await PolicyDataService.getByStatus(statusId);
        this.policies = res.data || [];
      } catch (err) {
        this.policies = [];
        this.$emit('error', err);
      } finally {
        this.loading = false;
      }
    },
    setActiveStatus(statusId) {
      this.activeStatusId = statusId;
      this.getPolicyByStatus(statusId);
    },
    formatDateDue(date_due) {
      const date = new Date(date_due);
      const now = new Date();
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const day = date.getDate();
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      const daySuffix = this.getDaySuffix(day);

      const formattedDate = `${month} ${day}${daySuffix}, ${year}`;
      const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
      const overdueText = diffInDays > 0 ? `(-${diffInDays} days overdue)` : '';

      return `Due: ${formattedDate} ${overdueText}`;
    },
    getDaySuffix(day) {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    },
  },
};
</script>

<style>
.tabbar {
  white-space: nowrap;
  overflow-x: auto;
}
</style>
